/* 面料色板，细节确认弹框 */
<template>
  <div :class="preflxCls">
    <z-dialog ref="projectlog" @close="closeDialog">
      <div class="Materiallog-main">
        <h2>{{details.name}}</h2>
        <p>{{details.target === 6 ? '色板' : '面料'}}编号：{{details.code || '暂无'}}</p>
        <p>使用部位：{{details.position || '暂无'}}</p>
        <div class="Materiallog-main-img" v-if="details.imageFile">
          <img
            :src="ossUrl + details.imageFile.key"
            alt
          />
          <!-- partFile -->
          <img class="position-img" v-if="details.partFile" :src="ossUrl + details.partFile.key" alt="">
        </div>
        <p>属性：{{details.nature || '暂无'}}</p>
        <div class="bottom_btn" v-if="!details.confirmed">
          <Button @click="sureDetails()" type="primary">{{details.target === 6 ? '确认色板' : '确认面料'}}</Button>
        </div>
      </div>
    </z-dialog>
  </div>
</template>
<script>
const preflxCls = "Materiallog";
import emitter from "../../mixins/emitter.js";
import dialogs from "../../mixins/dialogs.js";
import { findComponentDownward, randomString } from "../../utils/assist.js";
import ZDialog from "./dialog";
export default {
  name: "ZMateriallog",
  mixins: [emitter, dialogs],
  provide() {
    return {
      app: this,
      model: false
    };
  },
  data() {
    return {
      preflxCls: preflxCls
    };
  },
  props: {
    details: {
      type: [Object, String],
      default: ""
    },
    display: {
      type: Boolean,
      default: false
    },
    ossUrl: {
      type: String,
      default: ""
    },
  },
  components: { ZDialog },

  methods: {
    open() {
      this.diaologDom.op();
    },
    closeDialog() {
      this.$emit("close");
    },
    sureDetails() {
        this.$emit('sureDetailsHandle')
    }
  },

  watch: {
    display: function() {
      if (this.display) {
        this.diaologDom.op();
      } else {
        this.diaologDom.close();
      }
    }
  },

  mounted() {
    const Dialog = findComponentDownward(this, "ZDialog");
    if (Dialog) {
      this.diaologDom = Dialog;
    }
  }
};
</script> 

<style lang="scss">
.Materiallog {
  &-main {
    text-align: left;
    padding: 25px;
    p {
      margin-top: 5px;
      font-size: 14px;
    }
    &-img {
      width: 100%;
      margin-top: 10px;
      margin-bottom: 5px;
      position: relative;
      font-size: 0px;
      img {
        width: 100%;
      }
      .position-img {
          position: absolute;
          bottom:0px;
          right: 0px;
          max-width: 40%;
      }
    }
    .bottom_btn {
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>